import { render, staticRenderFns } from "./aalst.vue?vue&type=template&id=226cb82c"
import script from "./aalst.vue?vue&type=script&lang=js"
export * from "./aalst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports